<main class="leads">
  <header class="topo">
    <div class="topo__titulo">
      <a class="migalha" routerLink="/admin/mia-gestor"><i class="fas fa-chevron-left" aria-hidden="true"></i> Mia Gestor</a>
      <h1><span class="topo__icone"><i class="fas fa-user-plus" aria-hidden="true"></i></span>Leads</h1>
      <p>Arraste o cartão para mudar a etapa. O lead avança sozinho quando escreve para a Mia e quando cria o teste.</p>
    </div>
    <button type="button" class="primario" (click)="colarAberto = !colarAberto" [attr.aria-expanded]="colarAberto" aria-controls="painel-colar">
      <i class="fas" [class.fa-envelope-open-text]="!colarAberto" [class.fa-times]="colarAberto" aria-hidden="true"></i>
      {{ colarAberto ? 'Fechar' : 'Colar e-mail de lead' }}
    </button>
  </header>

  <!-- colar e-mail: recolhido por padrão; abre sozinho quando ainda não há lead -->
  <section id="painel-colar" class="colar" [class.colar--aberto]="colarAberto" [attr.aria-hidden]="!colarAberto">
    <div class="colar__dobra">
      <div class="cartao colar__cartao">
        <div class="colar__entrada">
          <p class="orientacao">Cole o e-mail "Form Whatsapp do site MeuCardápio" ou "LP Sistema CardapioDigital.com". Pode colar vários de uma vez.</p>
          <textarea rows="6" [(ngModel)]="emailColado" [disabled]="colando || !colarAberto" placeholder="Nome: ...&#10;Celular: ...&#10;Empresa: ..."
                    aria-label="E-mail do lead"></textarea>
          <div class="colar__acoes">
            <button type="button" class="primario" (click)="coleEmail()" [disabled]="colando || !emailColado.trim() || !colarAberto">
              <i class="fas" [class.fa-user-plus]="!colando" [class.fa-circle-notch]="colando" [class.girando]="colando" aria-hidden="true"></i>
              {{ colando ? 'Registrando…' : 'Registrar lead' }}
            </button>
            <div class="resultado" role="status" *ngIf="colagem">
              <span class="chip chip--novo"><b>{{ colagem.registrados }}</b> novo(s)</span>
              <span class="chip"><b>{{ colagem.duplicados }}</b> repetido(s)</span>
              <span class="chip chip--acordado"><b>{{ colagem.acordados }}</b> mensagem(ns) acordada(s)</span>
            </div>
          </div>
          <p class="faixa faixa--atencao" *ngIf="colagem && colagem.rejeitados.length"><i class="fas fa-exclamation-triangle" aria-hidden="true"></i>Ignorados: {{ colagem.rejeitados.join('; ') }}</p>
          <p class="faixa faixa--erro" role="alert" *ngIf="erroColagem"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erroColagem }}</p>
        </div>
        <ol class="passos" aria-label="Como funciona">
          <li><span>1</span><div><strong>Cole o e-mail</strong><small>A Mia lê nome, celular e empresa do formulário.</small></div></li>
          <li><span>2</span><div><strong>Telefone autorizado</strong><small>O celular do lead passa a ser atendido pela Mia Gestor.</small></div></li>
          <li><span>3</span><div><strong>Mensagens acordadas</strong><small>O que ele já mandou recentemente é entregue à Mia, que responde.</small></div></li>
        </ol>
      </div>
    </div>
  </section>

  <div class="barra">
    <label class="busca">
      <i class="fas fa-search" aria-hidden="true"></i>
      <input type="search" [(ngModel)]="busca" (ngModelChange)="distribua()" placeholder="Buscar nome, empresa, telefone…" aria-label="Buscar lead">
    </label>
    <div class="periodo" role="group" aria-label="Período">
      <button type="button" *ngFor="let d of periodos" [class.ativo]="d === diasLeads" [attr.aria-pressed]="d === diasLeads"
              (click)="mudePeriodo(d)" [disabled]="carregando">{{ d }} dias</button>
    </div>
    <span class="barra__total num" *ngIf="carregou">{{ totalVisivel }} de {{ leads.length }} lead(s)</span>
    <button type="button" class="icone" (click)="carregue()" [disabled]="carregando" aria-label="Atualizar" title="Atualizar">
      <i class="fas fa-sync-alt" [class.girando]="carregando" aria-hidden="true"></i>
    </button>
  </div>

  <p class="faixa faixa--erro" role="alert" *ngIf="erro"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erro }}</p>

  <div class="quadro" cdkDropListGroup [class.quadro--arrastando]="arrastando" [class.quadro--carregando]="carregando && !carregou">
    <section class="coluna" *ngFor="let c of colunas"
             [ngClass]="'coluna--' + c.id.toLowerCase()"
             [class.coluna--bloqueada]="arrastando && !podeIr(arrastando, c.id)"
             [attr.aria-label]="c.titulo">
      <header class="coluna__topo">
        <span class="coluna__ponto" aria-hidden="true"></span>
        <h2>{{ c.titulo }}</h2>
        <span class="coluna__qtd num">{{ porEtapa[c.id]?.length || 0 }}</span>
      </header>
      <p class="coluna__dica">
        <ng-container *ngIf="!(arrastando && !podeIr(arrastando, c.id))">{{ c.dica }}</ng-container>
        <ng-container *ngIf="arrastando && !podeIr(arrastando, c.id)"><i class="fas fa-lock" aria-hidden="true"></i> {{ motivoBloqueio(arrastando) }}</ng-container>
      </p>

      <div class="coluna__lista" cdkDropList [cdkDropListData]="c.id" [cdkDropListEnterPredicate]="podeEntrar"
           (cdkDropListDropped)="solte($event)">
        <ng-container *ngIf="carregou">
          <article class="lead-card" *ngFor="let l of porEtapa[c.id]; trackBy: porId"
                   cdkDrag [cdkDragData]="l" (cdkDragStarted)="arrastando = l" (cdkDragEnded)="arrastando = null"
                   [class.lead-card--selecionado]="selecionado?.id === l.id"
                   tabindex="0" role="button" [attr.aria-label]="nomeDe(l) + ', ' + c.titulo + '. Abrir detalhes'"
                   (click)="abra(l)" (keydown.enter)="abra(l)" (keydown.space)="$event.preventDefault(); abra(l)">
            <div class="lead-card__topo">
              <span class="avatar" [style.background]="corAvatar(l)[0]" [style.color]="corAvatar(l)[1]" aria-hidden="true">{{ iniciais(l) }}</span>
              <div class="lead-card__quem">
                <strong>{{ l.nome || telefoneFormatado(l.telefone) }}</strong>
                <small [class.fraco]="!l.empresa">{{ l.empresa || 'Empresa não informada' }}</small>
              </div>
              <time class="lead-card__tempo num" [attr.datetime]="l.ultimoFormularioEm" [title]="(l.ultimoFormularioEm | date:'dd/MM/yyyy HH:mm')">{{ tempoDesde(l.ultimoFormularioEm) }}</time>
            </div>
            <div class="lead-card__rodape">
              <span class="selo">{{ rotuloOrigem(l.origem) }}</span>
              <span class="selo selo--canal" *ngIf="l.canal" [title]="'Veio pelo ' + rotuloCanal(l.canal)"><i [ngClass]="iconeCanal(l.canal)" aria-hidden="true"></i>{{ rotuloCanal(l.canal) }}</span>
              <span class="lead-card__sinais">
                <i class="fas fa-comment-dots" *ngIf="l.primeiraMensagemEm" title="Já escreveu para a Mia" aria-label="Já escreveu para a Mia"></i>
                <i class="fas fa-flask" *ngIf="l.testeCriadoEm" title="Criou o teste" aria-label="Criou o teste"></i>
                <i class="fas fa-laptop" *ngIf="l.temComputador" title="Tem computador" aria-label="Tem computador"></i>
              </span>
            </div>
            <div class="lead-card-fantasma" *cdkDragPlaceholder></div>
          </article>

          <div class="coluna__vazio" *ngIf="!porEtapa[c.id]?.length">
            {{ busca ? 'Nenhum lead encontrado.' : c.vazio }}
          </div>
        </ng-container>

        <ng-container *ngIf="!carregou">
          <div class="lead-card lead-card--esqueleto" *ngFor="let _ of [1, 2]" aria-hidden="true"><span></span><span></span></div>
        </ng-container>
      </div>
    </section>
  </div>
</main>

<!-- detalhe do lead -->
<div class="fundo" *ngIf="selecionado" (click)="feche()" aria-hidden="true"></div>
<aside class="gaveta" [class.gaveta--aberta]="selecionado" role="dialog" aria-modal="true" [attr.aria-hidden]="!selecionado"
       aria-labelledby="gaveta-titulo">
  <ng-container *ngIf="exibido as l">
    <header class="gaveta__topo">
      <span class="avatar avatar--grande" [style.background]="corAvatar(l)[0]" [style.color]="corAvatar(l)[1]" aria-hidden="true">{{ iniciais(l) }}</span>
      <div class="gaveta__quem">
        <h2 id="gaveta-titulo">{{ nomeDe(l) }}</h2>
        <p>{{ l.empresa || 'Empresa não informada' }}</p>
      </div>
      <button type="button" class="icone" (click)="feche()" aria-label="Fechar"><i class="fas fa-times" aria-hidden="true"></i></button>
    </header>

    <div class="gaveta__acoes">
      <a class="botao primario" [href]="linkWhatsapp(l)" target="_blank" rel="noopener"><i class="fab fa-whatsapp" aria-hidden="true"></i>Abrir no WhatsApp</a>
      <button type="button" (click)="copieTelefone(l)">
        <i class="fas" [class.fa-copy]="!copiado" [class.fa-check]="copiado" aria-hidden="true"></i>{{ copiado ? 'Copiado' : 'Copiar telefone' }}
      </button>
    </div>

    <section class="gaveta__bloco">
      <h3>Etapa</h3>
      <div class="etapas" role="radiogroup" aria-label="Etapa do lead">
        <button type="button" *ngFor="let c of colunas" class="etapa" role="radio"
                [ngClass]="'etapa--' + c.id.toLowerCase()"
                [class.etapa--atual]="l.etapa === c.id" [attr.aria-checked]="l.etapa === c.id"
                [disabled]="!podeIr(l, c.id)" [title]="podeIr(l, c.id) ? c.dica : motivoBloqueio(l)"
                (click)="mova(l, c.id)">
          <span class="etapa__ponto" aria-hidden="true"></span>
          <span class="etapa__nome">{{ c.titulo }}</span>
          <i class="fas fa-check etapa__marca" aria-hidden="true"></i>
          <i class="fas fa-lock etapa__cadeado" *ngIf="!podeIr(l, c.id)" aria-hidden="true"></i>
        </button>
      </div>
    </section>

    <!-- memória: o que a Mia Gestor registrou na conversa comercial com este telefone -->
    <section class="gaveta__bloco memoria" [attr.aria-busy]="carregandoMemoria">
      <h3>O que a Mia sabe</h3>

      <div class="memoria__esqueleto" *ngIf="carregandoMemoria" aria-hidden="true"><span></span><span></span><span></span></div>
      <p class="faixa faixa--erro" role="alert" *ngIf="erroMemoria"><i class="fas fa-exclamation-circle" aria-hidden="true"></i>{{ erroMemoria }}</p>

      <p class="memoria__vazia" *ngIf="!carregandoMemoria && !erroMemoria && !memoria">
        <i class="fas fa-comment-slash" aria-hidden="true"></i>
        A Mia ainda não conversou com este lead. Quando ele escrever, o que ela descobrir aparece aqui.
      </p>

      <ng-container *ngIf="!carregandoMemoria && memoria as m">
        <div class="memoria__estado">
          <span class="pilula">{{ rotuloFase(m.fase) }}</span>
          <span class="pilula" [class.pilula--equipe]="m.controle?.pausada" [class.pilula--off]="m.controle?.bloqueada || m.controle?.habilitada === false">
            <span class="pilula__ponto" aria-hidden="true"></span>{{ estadoDaMia(m) }}
          </span>
        </div>

        <p class="memoria__encaminhamento" *ngIf="m.encaminhamento?.motivo">
          <i class="fas fa-hand-paper" aria-hidden="true"></i><span><strong>Pediu a equipe:</strong> {{ m.encaminhamento.motivo }}</span>
        </p>

        <div class="spin" *ngIf="spinDe(m) as spin">
          <div class="spin__barra" role="img" [attr.aria-label]="(spin.feitos.length - spin.falta.length) + ' de ' + spin.feitos.length + ' pontos da qualificação'">
            <span *ngFor="let feito of spin.feitos; let i = index" [class.feito]="feito" [class.dor]="i >= 6"></span>
          </div>
          <small class="num">Qualificação {{ spin.feitos.length - spin.falta.length }}/{{ spin.feitos.length }}</small>
          <p class="spin__falta" *ngIf="spin.falta.length">Falta saber: {{ spin.falta.join(', ') }}</p>
        </div>

        <a class="insta" *ngIf="m.ficha?.instagram?.perfil as perfil" [href]="perfil.url" target="_blank" rel="noopener">
          <span class="insta__icone" aria-hidden="true"><i class="fab fa-instagram"></i></span>
          <span class="insta__texto">
            <strong>{{ perfil.nome || perfil.handle }}</strong>
            <small class="num">&#64;{{ perfil.handle }}<ng-container *ngIf="perfil.seguidores != null"> · {{ perfil.seguidores | number:'1.0-0' }} seguidores</ng-container></small>
            <span class="insta__bio" *ngIf="perfil.bio">{{ perfil.bio }}</span>
          </span>
        </a>

        <dl class="fatos" *ngIf="fatosDe(m).length">
          <div *ngFor="let f of fatosDe(m)">
            <dt>{{ f.rotulo }}</dt>
            <dd>
              {{ f.fato.valor }}
              <q *ngIf="f.fato.evidencia && f.fato.evidencia !== f.fato.valor" [title]="f.fato.registradoEm ? ('Dito em ' + (f.fato.registradoEm | date:'dd/MM HH:mm')) : ''">{{ f.fato.evidencia }}</q>
            </dd>
          </div>
        </dl>
        <p class="memoria__vazia" *ngIf="!fatosDe(m).length">A conversa começou, mas a Mia ainda não registrou nada sobre a loja.</p>

        <div class="conversa" *ngIf="m.mensagens?.length">
          <div class="conversa__topo">
            <h4>Últimas mensagens</h4>
            <a routerLink="/admin/mia-gestor/comercial">Conversa completa <i class="fas fa-arrow-right" aria-hidden="true"></i></a>
          </div>
          <div class="conversa__lista">
            <div class="balao" *ngFor="let msg of m.mensagens.slice(-6)" [class.balao--mia]="msg.papel === 'gestor'" [class.balao--sistema]="msg.papel !== 'gestor' && msg.papel !== 'usuario'">
              <p>{{ msg.texto }}</p>
              <time class="num">{{ msg.papel === 'gestor' ? 'Mia' : (msg.papel === 'usuario' ? 'Lead' : 'Sistema') }} · {{ msg.criadoEm | date:'dd/MM HH:mm' }}</time>
            </div>
          </div>
        </div>
      </ng-container>
    </section>

    <section class="gaveta__bloco">
      <h3>Ficha do formulário</h3>
      <dl class="dados">
        <div><dt>WhatsApp</dt><dd class="num">{{ telefoneFormatado(l.telefone) }}</dd></div>
        <div><dt>E-mail</dt><dd><a *ngIf="l.email" [href]="'mailto:' + l.email">{{ l.email }}</a><span class="fraco" *ngIf="!l.email">—</span></dd></div>
        <div><dt>Instagram</dt><dd><a *ngIf="l.instagram" [href]="linkInstagram(l)" target="_blank" rel="noopener">&#64;{{ l.instagram }}</a><span class="fraco" *ngIf="!l.instagram">—</span></dd></div>
        <div><dt>Computador</dt><dd>{{ l.temComputador === null ? '—' : (l.temComputador ? 'Tem' : 'Não tem') }}</dd></div>
        <div><dt>Origem</dt><dd>{{ rotuloOrigem(l.origem) }}</dd></div>
        <div><dt>Canal</dt><dd>{{ l.canal ? rotuloCanal(l.canal) : '—' }}</dd></div>
        <div *ngIf="l.urlPagina"><dt>Página</dt><dd><a [href]="l.urlPagina" target="_blank" rel="noopener" [title]="l.urlPagina">{{ hostDe(l.urlPagina) }}</a></dd></div>
      </dl>
    </section>

    <section class="gaveta__bloco">
      <h3>Linha do tempo</h3>
      <ol class="tempo">
        <li class="tempo__item tempo__item--feito">
          <span class="tempo__ponto" aria-hidden="true"></span>
          <div><strong>Formulário</strong><small>{{ rotuloOrigem(l.origem) }}<ng-container *ngIf="l.canal"> · {{ rotuloCanal(l.canal) }}</ng-container></small></div>
          <time class="num">{{ l.ultimoFormularioEm | date:'dd/MM HH:mm' }}</time>
        </li>
        <li class="tempo__item" [class.tempo__item--feito]="l.primeiraMensagemEm">
          <span class="tempo__ponto" aria-hidden="true"></span>
          <div><strong>Escreveu para a Mia</strong><small *ngIf="!l.primeiraMensagemEm">Ainda não</small></div>
          <time class="num" *ngIf="l.primeiraMensagemEm">{{ l.primeiraMensagemEm | date:'dd/MM HH:mm' }}</time>
        </li>
        <li class="tempo__item" [class.tempo__item--feito]="l.testeCriadoEm">
          <span class="tempo__ponto" aria-hidden="true"></span>
          <div><strong>Criou o teste</strong><small *ngIf="!l.testeCriadoEm">Ainda não</small></div>
          <time class="num" *ngIf="l.testeCriadoEm">{{ l.testeCriadoEm | date:'dd/MM HH:mm' }}</time>
        </li>
      </ol>
    </section>

    <section class="gaveta__bloco excluir" [class.excluir--confirmando]="confirmandoExclusao">
      <p class="excluir__aviso" *ngIf="confirmandoExclusao" role="alert">
        O lead some do quadro e o telefone deixa de ser autorizado: a Mia Gestor para de responder a ele.
      </p>
      <div class="excluir__acoes">
        <button type="button" class="perigo" (click)="exclua(l)" [disabled]="excluindo">
          <i class="fas" [class.fa-trash-alt]="!excluindo" [class.fa-circle-notch]="excluindo" [class.girando]="excluindo" aria-hidden="true"></i>
          {{ excluindo ? 'Excluindo…' : (confirmandoExclusao ? 'Excluir de vez' : 'Excluir lead') }}
        </button>
        <button type="button" class="fantasma" *ngIf="confirmandoExclusao && !excluindo" (click)="confirmandoExclusao = false">Cancelar</button>
      </div>
    </section>
  </ng-container>
</aside>

<div class="aviso" role="status" aria-live="polite" [class.aviso--visivel]="aviso">
  <ng-container *ngIf="aviso">
    <span>{{ aviso.texto }}</span>
    <button type="button" *ngIf="aviso.desfazer" (click)="desfaca()">Desfazer</button>
  </ng-container>
</div>
